import { __rest, __assign } from '../node_modules/tslib/tslib.es6.js';
import React, { useState } from 'react';

var FallbackImage = function (_a) {
    var fallbackImage = _a.fallbackImage, src = _a.src, props = __rest(_a, ["fallbackImage", "src"]);
    // fallback image should only be defined if there's an error loading the original image
    var _b = useState(undefined), fallbackImgSrc = _b[0], setFallbackImgSrc = _b[1];
    var imgSrc = fallbackImgSrc || src;
    return React.createElement("img", __assign({}, props, { onError: function () { return setFallbackImgSrc(fallbackImage); }, src: imgSrc }));
};

export { FallbackImage };
//# sourceMappingURL=FallbackImage.js.map
